import _DSC0313 from './_DSC0313.JPG'
import a2 from "./a2.png"
import anadir from "./anadir.png"
import cara_icono1 from "./cara_icono1.png"
import cara_icono2 from "./cara_icono2.png"
import chamba_ticon from "./chamba-ticon.png"
import cliente from "./cliente.png"
import dinero from "./dinero.png"
import fondo_header from "./fondo_header.png"
import footer_home from "./footer_home.png"
import image_header from "./image_header.png"
import lupa from "./lupa.png"
import a3 from "./a3.png"
import a4 from "./a4.png"
import a5 from "./a5.png"
import disenador_grafico from "./disenador-grafico.png"
import camara_de_video from "./camara-de-video.png"
import fotografo from "./fotografo.png"
import app from "./app.png"
import desarrollo from "./desarrollo.png"
import publicidad_digital from "./publicidad-digital.png"

export default {
    "_DSC0313": _DSC0313,
    "a2": a2,
    "anadir": anadir,
    "cara_icono1": cara_icono1,
    "cara_icono2": cara_icono2,
    "chamba_ticon": chamba_ticon,
    "cliente": cliente,
    "dinero": dinero,
    "fondo_header": fondo_header,
    "footer_home": footer_home,
    "image_header": image_header,
    "lupa": lupa,
    "a3": a3,
    "a4": a4,
    "a5": a5,
    "disenador_grafico": disenador_grafico,
    "camara_de_video": camara_de_video,
    "fotografo": fotografo,
    "app": app,
    "desarrollo": desarrollo,
    "publicidad_digital": publicidad_digital
}